import { IRequestLoginApiService, RequestLoginDto } from '@api/api.service';
import { NEVER, Observable } from 'rxjs';

export class RequestLoginApiMockService implements IRequestLoginApiService {
  requestNewLoginCredentials(requestLoginDto: RequestLoginDto): Observable<void> {
    return NEVER;
  }
}
